var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{staticClass:"addbutton",attrs:{"size":"large"},on:{"click":_vm.CheckHistoryPicture}},[_vm._v("检查历史事件图片")]),_c('Button',{staticClass:"addbutton",attrs:{"size":"large"},on:{"click":_vm.CheckRecipeStepPicture}},[_vm._v("检查菜谱步骤图片")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }